import type { FaseView } from '../lib/timeline'
import { dataBR } from '../lib/format'

function noClasses(estado: FaseView['estado']): string {
  switch (estado) {
    case 'concluida':
      return 'bg-green-600 text-white'
    case 'atual':
      return 'bg-pfa-coral text-white animate-pulse'
    case 'alerta':
      return 'bg-amber-400 text-white'
    default:
      return 'border-2 border-pfa-line bg-pfa-mist text-transparent'
  }
}

// Linha do tempo do caso, estilo "rastreio": concluído = navy + check, atual = coral
// pulsante, futuro = cinza translúcido. Verde só com fato; futuras são "previstas".
export function TimelineCaso({ fases }: { fases: FaseView[] }) {
  if (!fases.length) return null
  return (
    <div>
      <ol className="relative">
        {fases.map((f, i) => {
          const last = i === fases.length - 1
          const futura = f.estado === 'futura'
          return (
            <li key={f.chave} className="relative flex gap-3 pb-6 last:pb-0">
              {!last && (
                <span
                  className={`absolute bottom-0 left-[11px] top-7 w-px ${
                    f.estado === 'concluida' ? 'bg-green-600/40' : 'bg-pfa-line'
                  }`}
                />
              )}
              <span
                aria-hidden
                className={`z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold ${noClasses(
                  f.estado,
                )}`}
              >
                {f.estado === 'concluida' ? '✓' : f.estado === 'alerta' ? '!' : ''}
              </span>
              <div className={`-mt-0.5 ${futura ? 'opacity-60' : ''}`}>
                <p className="flex flex-wrap items-center gap-x-2 text-sm font-medium">
                  <span className={futura || f.estado === 'alerta' ? 'text-pfa-slate' : 'text-pfa-navy'}>{f.label}</span>
                  {f.prevista && f.estado !== 'concluida' && (
                    <span className="rounded-full bg-pfa-navy/5 px-1.5 py-0.5 text-[10px] font-normal uppercase tracking-wide text-pfa-slate/70">
                      prevista
                    </span>
                  )}
                  {f.estado === 'atual' && <span className="text-[11px] font-normal text-pfa-coral">• etapa atual</span>}
                </p>
                <p className="mt-0.5 text-xs leading-snug text-pfa-slate/80">{f.descricao}</p>
                {f.data && <p className="mt-0.5 text-[11px] text-pfa-slate/60">{dataBR(f.data)}</p>}
              </div>
            </li>
          )
        })}
      </ol>
      <p className="mt-4 border-t border-pfa-line pt-3 text-[11px] leading-relaxed text-pfa-slate/60">
        Esta linha do tempo mostra as etapas típicas de uma ação como a sua. As etapas previstas dependem de decisões da
        Justiça e dos prazos do processo — servem para acompanhar e{' '}
        <strong>não são garantia de resultado, valor ou prazo</strong>.
      </p>
    </div>
  )
}
